
import { defineComponent } from "@vue/runtime-core";
import { SamplingPointStation } from "@/types/samplingPointStation.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { postSamplingPointStation, getNewName } from "@/service/samplingpointstation.service";

import { Station } from "@/types/station.type";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";

export default defineComponent({
  props: {
    samplingPoint: {
      type: Object as () => SamplingPoint,
      required: true,
    },
  },
  setup() {
    const store = useStore<RootState>();
    return { store };
  },
  data() {
    return {
      form: {} as SamplingPointStation,
      stationsSelects: [] as Station[],
    };
  },
  computed: {
    stations(): Station[] {
      return this.store.state.station.stations;
    },
  },
  async mounted() {
    if (this.samplingPoint.code) {
      await getNewName(this.samplingPoint.code).then((name: string) => {
        if (this.form) {
          this.form.name = name;
        }
      });
    }
  },
  methods: {
    async doSave() {
      this.form.samplingPoint = this.samplingPoint;

      return postSamplingPointStation(this.form);
    },
  },
});
